import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import NotificationsManager from '../components/Notifications/NotificationsManager';

export default function NotificationsPage() {
  return (
    <Container maxWidth={false}>
      <Box sx={{ mt: 10, mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Notification Management
        </Typography>
        <NotificationsManager />
      </Box>
    </Container>
  );
} 